import styled from "styled-components";
import { styledByTheme } from "../../../../../themes/architecture/styled-by-theme";
import { JackpotThemeType } from "../../../../../services/jackpots-with-state/jackpots-with-state.service.interface";
import {JACKPOT_WIDGET_LAYOUT} from "../../../jackpot-widget.component";

interface IJackpotWidgetAmountLabelBox {
    layout: JACKPOT_WIDGET_LAYOUT;
    widgetWidth: number;
    themeType: JackpotThemeType;
}

const handleAmountLabelFontSize = (layout: JACKPOT_WIDGET_LAYOUT, widgetWidth: number) => {
    switch (layout) {
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE:
            /** In landscape view at a widget width of 468px, the amount should be of font-size 15px */
            return widgetWidth * 15 / 468 + "px";
        case JACKPOT_WIDGET_LAYOUT.LANDSCAPE_WIDE:
            /** In minimized view at a widget width of 375px, the amount should be of font-size 9px */
            return widgetWidth * 9 / 375 + "px";
        case JACKPOT_WIDGET_LAYOUT.PORTRAIT:
        default:
            /** In portrait view at a widget width of 131px, the amount should be of font-size 9px */
            return widgetWidth * 9 / 131 + "px";
    }
};

/**
 * This is the "PAID" label shown above the amount at cold state
 */
const JackpotWidgetAmountLabelDefaultBox = styled.div<IJackpotWidgetAmountLabelBox>`
    width: 100%;
    margin: 0 auto;
    text-align: center;
    letter-spacing: 0.2rem;

    text-transform: uppercase;
    color: ${({theme}) => theme.colors.textLight};
    ${({theme}) => theme.font.presets.ultra};

    font-size: ${({widgetWidth, layout}) => handleAmountLabelFontSize(layout, widgetWidth)};
`;

const JackpotWidgetAmountLabelCasino777Box = styled(JackpotWidgetAmountLabelDefaultBox)`
    color: ${(props) => props.themeType === JackpotThemeType.Light ? props.theme.colors.brandPrimaryContrast : props.theme.colors.brandSecondary};
`;

const JackpotWidgetAmountLabelSiBox = styled(JackpotWidgetAmountLabelDefaultBox)`
    color: ${({theme}) => theme.colors.textContrast };
`;

export const JackpotWidgetAmountLabelBox = styledByTheme(JackpotWidgetAmountLabelDefaultBox)
    .forCasino777(JackpotWidgetAmountLabelCasino777Box)
    .forSI(JackpotWidgetAmountLabelSiBox)
    .apply();
